import CustomLink, {
  LinkParams
} from 'common/components/anchors/custom-navlink';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';

export interface TileContent {
  title: string;
  message: string;
  linkDetails: LinkParams;
}

const HelpTile: FC<{ helpTile: TileContent }> = ({
  helpTile: { title, message, linkDetails }
}: {
  helpTile: TileContent;
}) => {
  return (
    <>
      <div className="p-6 bg-secondary-400 rounded text-lg">
        <article className="flex flex-col h-full mb-2 justify-between">
          <header className="text-white font-medium">{title}</header>

          <p className="mt-1 text-md text-white">{message}</p>

          <CustomLink linkParams={linkDetails}></CustomLink>
        </article>
      </div>
    </>
  );
};

export default HelpTile;
